import fetch from '../fetch';
import EndPoints from '../../data/EndPoints';
import Methods from '../../data/Methods';

export default () => {
	const headers = { 'content-type': 'application/json' };
	return fetch(Methods.GET, EndPoints.POLICY_TERMS, null, headers, true);
};
